(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    // Hover Zoom Implementation for Desktop Only - No Click
  // Mobile click zoom remains fully functional
  class ProductHoverZoom {
    constructor(container, options = {}) {
      this.container = container;
      this.image = container.querySelector('.product-media__image');
      this.zoomLevel = options.zoomLevel || 2;
      this.isDesktop = window.innerWidth >= 750;
      
      if (!this.image || !this.isDesktop) return;
      
      this.init();
    }
    
    init() {
      // Add hover zoom class
      this.container.classList.add('product-media-container--hover-zoom');
      
      // Setup hover zoom
      this.setupHoverZoom();
    }
    
    setupHoverZoom() {
      this.container.addEventListener('mouseenter', () => {
        this.image.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      });
      
      this.container.addEventListener('mousemove', (e) => {
        const rect = this.image.getBoundingClientRect();
        let x = ((e.clientX - rect.left) / rect.width) * 100;
        let y = ((e.clientY - rect.top) / rect.height) * 100;
        
        // Clamp values to prevent overflow
        x = Math.min(Math.max(x, 0), 100);
        y = Math.min(Math.max(y, 0), 100);
        
        this.image.style.transformOrigin = `${x}% ${y}%`;
        this.image.style.transform = `scale(${this.zoomLevel})`;
      });
      
      this.container.addEventListener('mouseleave', () => {
        this.image.style.transform = 'scale(1)';
        this.image.style.transformOrigin = 'center';
      });
    }
  }
  
  // Initialize hover zoom on desktop only, and prevent click zoom on desktop
  function initHoverZoom() {
    if (window.innerWidth >= 750) {
      // Desktop: add hover zoom and block clicks
      const zoomContainers = document.querySelectorAll('.product-media-container--zoomable.product-media-container--image');
      
      zoomContainers.forEach(container => {
        if (!container.hasAttribute('data-hover-zoom-initialized')) {
          new ProductHoverZoom(container, { zoomLevel: 2 });
          container.setAttribute('data-hover-zoom-initialized', 'true');
        }
        
        // Prevent click zoom on desktop (override the on:click attribute)
        container.style.pointerEvents = 'auto'; // keep hover working
        // Remove or override the click handler
        const clonedContainer = container.cloneNode(true);
        const oldClickAttr = container.getAttribute('on:click');
        if (oldClickAttr && oldClickAttr.includes('zoom-dialog')) {
          container.removeAttribute('on:click');
          // Also remove click from any child button
          const zoomBtn = container.querySelector('.product-media-container__zoom-button');
          if (zoomBtn) zoomBtn.removeAttribute('on:click');
        }
      });
      
      // Also prevent zoom dialog from opening via global click listener
      document.addEventListener('click', function(e) {
        const target = e.target.closest('[on\\:click*="zoom-dialog"]');
        if (target) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }, true);
      
    } else {
      // Mobile: ensure click zoom works (do nothing extra)
      // Remove hover zoom class if present
      document.querySelectorAll('.product-media-container--hover-zoom').forEach(container => {
        container.classList.remove('product-media-container--hover-zoom');
        const img = container.querySelector('.product-media__image');
        if (img) {
          img.style.transform = '';
          img.style.transformOrigin = '';
        }
        container.removeAttribute('data-hover-zoom-initialized');
      });
    }
  }
  
  // Handle resize events
  let resizeTimer;
  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initHoverZoom();
    }, 250);
  }
  
  // Initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverZoom);
  } else {
    initHoverZoom();
  }
  
  // Watch for dynamic content (variant changes)
  const observer = new MutationObserver(() => initHoverZoom());
  const galleryObserver = new MutationObserver(() => {
    const gallery = document.querySelector('media-gallery');
    if (gallery) {
      initHoverZoom();
      observer.observe(gallery, { childList: true, subtree: true });
      galleryObserver.disconnect();
    }
  });
  galleryObserver.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', handleResize);
  } catch(e) { console.error(e); }
})();

})();
